import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qbank-structures';

const ELEMENTS = define({
  CREATE_BUTTON: ['create', 'button'],
  CREATE_FORM: ['create', 'form'],
  CREATE_FORM_SUBMIT_BUTTON: ['create-form', 'submit', 'button'],
  SETUP_LEVEL_FORM_SUBMIT_BUTTON: ['setup-level-form', 'submit', 'button'],
});

export const QBS_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
